import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import MovieCard from '../movie-card/MovieCard';

const TrailerOnlyList = ({ genreId, type = 'new', size = 100 }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef(null);

    useEffect(() => {
        let url;
        if (genreId) {
            url = `/movies-public-api.php?type=trailer&genreId=${genreId}&page=0&size=${size}`;
        } else if (type === 'popular') {
            url = `/movies-public-api.php?type=trailer&order=popular&page=0&size=${size}`;
        } else {
            url = `/movies-public-api.php?type=trailer&page=0&size=${size}`;
        }
        setLoading(true);
        fetch(url)
            .then(r => r.json())
            .then(d => { if (d.success) setItems(d.content || []); })
            .catch(() => {})
            .finally(() => setLoading(false));
    }, [genreId, type, size]);

    const updateNav = s => { setIsBeginning(s.isBeginning); setIsEnd(s.isEnd); };
    const slidePrev = () => { const s = swiperRef.current; if (!s) return; const c = s.slidesPerViewDynamic ? s.slidesPerViewDynamic() : 1; s.slideTo(Math.max(0, s.activeIndex - c)); };
    const slideNext = () => { const s = swiperRef.current; if (!s) return; const c = s.slidesPerViewDynamic ? s.slidesPerViewDynamic() : 1; s.slideTo(s.activeIndex + c); };

    if (loading) return <div style={{ padding: '20px 0', color: '#555' }}>Loading...</div>;
    if (!items.length) return null;

    return (
        <div className="ranked-list" style={{ position: 'relative' }}>
            {!isBeginning && (
                <button className="ranked-list__nav ranked-list__nav--prev" onClick={slidePrev}>
                    <FaChevronLeft />
                </button>
            )}
            {!isEnd && (
                <button className="ranked-list__nav ranked-list__nav--next" onClick={slideNext}>
                    <FaChevronRight />
                </button>
            )}
            <Swiper
                grabCursor
                spaceBetween={8}
                slidesPerView="auto"
                onSwiper={s => { swiperRef.current = s; updateNav(s); }}
                onSlideChange={updateNav}
                onReachBeginning={() => { setIsBeginning(true); setIsEnd(false); }}
                onReachEnd={() => { setIsEnd(true); setIsBeginning(false); }}
                onFromEdge={s => updateNav(s)}
            >
                {items.map(item => (
                    <SwiperSlide key={item.id} style={{ width: 'auto' }}>
                        <MovieCard trailerMode={true} item={{
                            id:               item.id,
                            title:            item.title,
                            poster_path:      item.posterUrl,
                            backdrop_path:    item.thumbnailUrl || item.posterUrl,
                            slug:             item.slug,
                            releaseYear:      item.releaseYear,
                            duration:         item.duration,
                            averageRating:    item.averageRating,
                            episodeCount:     item.episodeCount,
                            latestEpisode:    item.latestEpisode,
                            status:           item.status,
                            genres:           item.genres,
                            description:      item.description,
                            country:          item.country,
                            trailerUrl:       item.trailerUrl,
                            restrictedAccess: item.restrictedAccess,
                            quality:          item.quality,
                        }} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default TrailerOnlyList;
